import Dropdown from "flowbite/lib/esm/components/dropdown"
import PopperBase from "./popper_base"

// Flowbite dropdown on its trigger — see popper_base.js.
//
//   <button data-controller="dropdown" data-dropdown-id-value="menu">
//   <div id="menu">…</div>
export default class extends PopperBase {
  static values = {
    placement: { type: String, default: "bottom" },
    triggerType: { type: String, default: "click" },
    offsetSkidding: { type: Number, default: 0 },
    offsetDistance: { type: Number, default: 10 },
    delay: { type: Number, default: 300 },
    ignoreClickOutsideClass: String,
  }

  _create(menu, instanceId) {
    return new Dropdown(
      menu,
      this.element,
      {
        placement: this.placementValue,
        triggerType: this.triggerTypeValue,
        offsetSkidding: this.offsetSkiddingValue,
        offsetDistance: this.offsetDistanceValue,
        delay: this.delayValue,
        ignoreClickOutsideClass: this.ignoreClickOutsideClassValue || false,
      },
      { id: instanceId, override: false },
    )
  }

  // Flowbite's dropdown opens on click (plus mouseenter in hover mode) and
  // never on focus, so the fallback shouldn't either.
  _fallbackEvents() {
    return this.triggerTypeValue === "hover"
      ? ["mouseenter", "click"]
      : ["click"]
  }
}
